(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teamstatistics/assets/javascripts/views/statteamstatistics.js') >= 0) return;  svs.modules.push('/components/statistics/teamstatistics/assets/javascripts/views/statteamstatistics.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.views = svs.statistics.views || {};
  svs.statistics.data = svs.statistics.data || {};

  svs.statistics.views.StatTeamStatistics = svs.statistics.views.StatBase.extend(
    {
      tagName: 'div',
      classId: 'StatTeamStatistics',
      teamId: -1,
      leagueId: -1,
      matchNoFilter: 0,
      numOfMatches: 5,
      events: {
        'change #playerStatsLeagueFilter': 'selectMenu'
      },
      filters: {
        playerStatsLeagueFilter: {
          filterValues: {},
          selectedKey: 'all'
        }
      },
      options: null,
      initialize: function(options) {
        if (!options.params.teamId) {
          return;
        }
        this.disposeSubviews();
        this.resetView();
        this.setupView(this.options);
        this.teamId = this.options.params.teamId;

        this.leagueByTeamModel = new svs.statistics.models.StatTeamStatistics({
          teamId: this.options.params.teamId
        });
        this.leagueByTeamModel.on(
          'change',
          this.requestCurrentLeagueService,
          this
        );
        this.leagueByTeamModel.fetch();
        this.options = options;
      },
      requestCurrentLeagueService: function() {
        var leagues = this.leagueByTeamModel.get('leagues');
        this.leagueId = 0;

        if (window.location.href.indexOf('leagueId') > -1) {
          this.leagueId = svs.utils.url.queryString.leagueId;
        }

        leagues = _.sortBy(leagues, function(leaguestat) {
          return leaguestat.id;
        });

        if (_.isArray(leagues) && this.leagueId === 0) {
          if (leagues.length > 0) {
            this.leagueId = leagues[0].id;
          } else {
            this.$el.html(svs.statistics.statistics.templates.nodata({}));
            return;
          }
        }
        this.teamId = this.options.params.teamId;
        this.leagueByTeamModel.setCurrentStatistics(
          this.options.params.teamId,
          this.leagueId
        );
        this.leagueByTeamModel.off('change', this.requestCurrentLeagueService);
        this.leagueByTeamModel.on(
          'change',
          this.requestStatisticsService,
          this
        );
      },
      requestStatisticsService: function() {
        this.leagueByTeamModel.off('change', this.requestStatisticsService);
        this.leagueByTeamModel.on('change', this.render, this);
        this.leagueByTeamModel.on(
          'change:teamFormLatestMatches',
          this.updateSubview,
          this
        );
        this.leagueByTeamModel.setCurrentTeam(this.teamId);

        if (window.location.href.indexOf('sportId') > -1) {
          this.leagueByTeamModel.set(
            'sport',
            { id: svs.utils.url.queryString.sportId },
            { silent: true }
          );
        }
        this.model = this.leagueByTeamModel;
      },
      setupView: function(options) {
        this.statTeamFormLatestMatches = new svs.statistics.views.StatTeamFormLatestMatches(
          { options: options }
        );
        this.views.push(this.statTeamFormLatestMatches);

        this.statTeamPowerBoxPlay = new svs.statistics.views.StatTeamPowerBoxPlay(
          { options: options }
        );
        this.views.push(this.statTeamPowerBoxPlay);

        this.statTeamOffenseDefense = new svs.statistics.views.StatTeamOffenseDefense(
          { options: options }
        );
        this.views.push(this.statTeamOffenseDefense);

        this.statTeamPlayerStatistics = new svs.statistics.views.StatTeamPlayerStatistics(
          { options: options }
        );

        this.views.push(this.statTeamPlayerStatistics);

        this.events = _.extend({}, this.genericEvents, this.events);
        this.delegateEvents();
      },
      disposeSubviews: function() {
        _.each(this.views, function(view) {
          view.dispose();
        });
        this.views = [];
      },
      updateSubview: function() {
        this.statTeamPlayerStatistics.update(this.model);
        this.statTeamFormLatestMatches.update(this.model);
        this.statTeamPowerBoxPlay.update(this.model);
        if (svs.utils.ns.isNamespace('attributes.sport.id', this.model)) {
          if (
            this.model.get('sport').id !==
            svs.statistics.constants.AMERICAN_FOOTBALL
          ) {
            this.statTeamOffenseDefense.update(this.model);
          }
        }
      },
      update: function() {
        var _self = this;
        if (svs.statistics.data.content) {
          this.model.set(svs.statistics.data.content);
          svs.statistics.data.content = null; 
        } else {
          this.model.fetch({
            error: function() {
              _self.$el.html(svs.statistics.statistics.templates.tryagain({}));
              _self.$('.js-statistics-reload').bind('click', function() {
                $(this).unbind('click');
                _self.update();
              });
            }
          });
        }
      },
      render: function() {
        if (!this.model) {
          this.$el.html(
            svs.statistics.statistics.templates.nodata({
              renderEmpty: this.options.params.preDraw
            })
          );
          return this;
        }

        this.$el.html(
          svs.statistics.teamstatistics.templates.statteamstatistics(
            this.applyFilters()
          )
        );
        this.statTeamPlayerStatistics
          .setElement(this.$('#statTeamPlayerStatistics'))
          .delegateEvents()
          .render();
        this.statTeamPowerBoxPlay
          .setElement(this.$('#statTeamPowerBoxPlay'))
          .delegateEvents()
          .render();
        if (svs.utils.ns.isNamespace('attributes.sport.id', this.model)) {
          if (
            this.model.get('sport').id !==
            svs.statistics.constants.AMERICAN_FOOTBALL
          ) {
            this.statTeamOffenseDefense
              .setElement(this.$('#statTeamOffenseDefense'))
              .delegateEvents()
              .render();
          }
        }
        this.statTeamFormLatestMatches
          .setElement(this.$('#teamLatestMatchesContent'))
          .delegateEvents()
          .render();

        if (
          Object.prototype.hasOwnProperty.call(this.options.params, 'parent')
        ) {
          this.options.params.parent.trigger('resize');
        }
        return this;
      },
      applyFilters: function() {
        var leagues = this.model.get('leagues');
        leagues = this.setupLeagueDropDownModule(leagues);
        this.hideLoader();
        return {
          players: {},
          leagues: leagues,
          filters: this.filters
        };
      },
      setupLeagueDropDownModule: function(leagues) {
        var self = this,
          menuItemsCounter = 0;
        if (_.size(this.filters.playerStatsLeagueFilter.filterValues) < 2) {
          leagues = _.sortBy(leagues, function(leaguestat) {
            return leaguestat.rank;
          });
          _.each(leagues, function(leaguestat) {
            if (self.leagueId === leaguestat.id) {
              self.filters.playerStatsLeagueFilter.filterValues[
                leaguestat.id
              ] = { name: leaguestat.name, selected: true };
            } else {
              self.filters.playerStatsLeagueFilter.filterValues[
                leaguestat.id
              ] = { name: leaguestat.name, selected: false };
            }

            self.filters.playerStatsLeagueFilter.menuItemsCounter = ++menuItemsCounter;
          });
        }
        return leagues;
      },
      setupLeagueDropDownModuleTest: function(oTest) {
        if (oTest === -1) {
          throw new Error();
        } else if (oTest) {
          oTest.name = oTest.name + '_test';
        } else {
          oTest = null;
        }

        return oTest;
      },
      selectMenu: function(event) {
        var selectedVal = $(event.currentTarget).val();
        this.filters[
          $(event.currentTarget).attr('id')
        ].selectedKey = selectedVal;

        _.each(
          this.filters[$(event.currentTarget).attr('id')].filterValues,
          function(filterValue) {
            filterValue.selected = false;
          }
        );
        this.filters[$(event.currentTarget).attr('id')].filterValues[
          selectedVal
        ].selected = true;

        if ($(event.currentTarget).attr('id') === 'playerStatsLeagueFilter') {
          this.teamId = this.model.get('originalTeamId'); 
          this.leagueId = this.filters.playerStatsLeagueFilter.selectedKey;
          this.leagueByTeamModel.off('change', this.render);
          this.leagueByTeamModel.off(
            'change:teamFormLatestMatches',
            this.updateSubview,
            this
          );
          this.leagueByTeamModel.on(
            'change',
            this.requestStatisticsService,
            this
          );
          this.model.setCurrentStatistics(this.teamId, this.leagueId);
          this.showLoader();
          return;
        }
        this.render({});
      },
      resetView: function() {

        this.filters.playerStatsLeagueFilter = {
          filterValues: {},
          selectedKey: 'all'
        };
      },
      onDestroy: function() {
        if (this.closeHandler) this.closeHandler();

        this.undelegateEvents();
        this.stopListening();
        this.unbind();
        this.disposeSubviews();
        this.views = null;
      }
    }
  );
})(Backbone, _, svs);

 })(window);